/**
 * Prepends each space-delimited classname in the value with the specified key.
 *
 * @config Record<string, string>
 * Key represents the value to prepend, value represents the space-delimited values the key will be prepended to
 * @remarks This utility simplifies the authoring of tailwind classnames where several classnames require a pseudo
 * selector or breakpoint. Specify the value to prepend as a key, such as a screen size (ex xxs), and the classnames you
 * wish to have prepended with that key as the value delimited by spaces
 */
export const prepend = (config: Record<string, string>) =>
  Object.entries(config).reduce(
    (prev: string[], [key, value]) => [
      ...prev,
      value.split(" ").join(`${key}:`),
    ],
    [],
  );
